/* ----------------------------------------------------------------------------------------
 * CUSTOM RING SIZE LOCALIZER (Tier 1, additive)
 * Created: 2026-05-06
 *
 * Rewrites the visible text of ring-size variant-picker labels based on the active market.
 * Reads window.customRingSizeConfig (set by snippets/custom-ring-size-localizer.liquid).
 * Never touches input value attributes (those are metaobject GIDs) — cart/checkout/orders
 * remain on the canonical US size, by design.
 *
 * To revert: delete this file, snippets/custom-ring-size-localizer.liquid, and the wrapped
 * render block in layout/theme.liquid.
 * ---------------------------------------------------------------------------------------- */

(function () {
  var config = window.customRingSizeConfig;
  if (!config || !config.target || !config.mapping) return;

  var mapping = config.mapping;
  var target = config.target;

  // Gate on the fieldset's <legend> text. The current option name is "Size" (English),
  // and on translated markets it may appear as "Größe", "Taille", "Talla", etc. We also
  // include "ring"-rooted terms in case the option ever gets renamed to "Ring size" or
  // its translations ("Ringgröße", "Ringmaat", "Bague", "Anillo", …).
  // The secondary value-match guard below prevents accidental rewrites on unrelated
  // "Size" options (earring mm, bracelet cm, etc.) since their values won't match the
  // US ring-size mapping keys.
  var RING_LEGEND_TERMS = [
    'size', 'ring', 'taille', 'taglia', 'misura', 'talla', 'tamanho',
    'größe', 'grosse', 'storlek', 'størrelse', 'koko', 'rozmiar', 'maat',
    'bague', 'anneau', 'anillo', 'anello', 'anel'
  ];

  function isRingSizeFieldset(fieldset) {
    var legend = fieldset.querySelector('legend');
    if (!legend) return false;
    var text = (legend.textContent || '').toLowerCase();
    for (var i = 0; i < RING_LEGEND_TERMS.length; i++) {
      if (text.indexOf(RING_LEGEND_TERMS[i]) !== -1) return true;
    }
    return false;
  }

  function localizeFieldset(fieldset) {
    if (!isRingSizeFieldset(fieldset)) return;

    var spans = fieldset.querySelectorAll('span');
    // Defence in depth: also require at least 2 visible values to match the US
    // ring-size mapping. If a non-ring option ever happens to have "ring" in its
    // legend text but unrelated values, this guard prevents accidental rewrites.
    var matchCount = 0;
    for (var i = 0; i < spans.length; i++) {
      var text = (spans[i].textContent || '').trim();
      if (Object.prototype.hasOwnProperty.call(mapping, text)) matchCount++;
    }
    if (matchCount < 2) return;

    for (var j = 0; j < spans.length; j++) {
      var span = spans[j];
      if (span.children.length > 0) continue;
      var key = (span.textContent || '').trim();
      var entry = mapping[key];
      if (entry && entry[target]) span.textContent = entry[target];
    }
  }

  function localizeAll() {
    var fieldsets = document.querySelectorAll('fieldset.variant-picker__option');
    for (var i = 0; i < fieldsets.length; i++) localizeFieldset(fieldsets[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', localizeAll);
  } else {
    localizeAll();
  }

  document.addEventListener('variant:change', function () {
    setTimeout(localizeAll, 50);
  });
})();
